import React, { memo } from 'react'
import PropTypes from 'prop-types'
import Jackpot from '../../Jackpot/Jackpot'
import { shallowEqual, useSelector } from 'react-redux'
import st from 'scss/Mobile.module.scss'
import cx from 'classnames'

const Jackpots = memo(({ className, wrapperClass }) => {
	const jackpot = useSelector((state) => state?.jackpot, shallowEqual)

	return (
		<div className={cx(st.jackpots, wrapperClass)}>
			{jackpot?.data.map((jp) => (
				<Jackpot
					key={jp['ID']}
					id={jp['ID']}
					title={jackpot.types[jp['ID']]}
					value={jp['AMOUNT'] / 100}
					digits={8}
					type={'mob'}
					noClick={true}
					className={className}
				/>
			))}
		</div>
	)
})
Jackpots.propTypes = {
	className: PropTypes.string,
}

export default Jackpots
